import Backbone from 'backbone'
import _ from 'lodash'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import formHelper from 'scoreboard/components/form-helper'
import template from './config-widget-label.hbs'
import i18n from 'scoreboard/components/i18n'
import MarkedField from 'scoreboard/components/marked-field'
import FormView from 'scoreboard/components/form-view'
import requiredValidator from 'scoreboard/components/validators/required-validator'

/**
 * View for editing a widget's label. Must implement dialogTitle, _getModelLabel, _setModelLabel, and _getSuggestion
 */
var ConfigWidgetLabel = Backbone.View.extend({
	className: 'config-widget-label',
	tagName: 'form',
	toggleLabel: 'charts.showLabel',

	initialize(options = {}) {
		this.options = options
	},

	render: function () {
		this.$el.append(template({
			dialogTitle: _.result(this, 'dialogTitle'),
			label: this._getModelLabel()
		}))

		this.toggle = new OnOffToggle({
			name: 'showLabel',
			checked: !!this._getModelLabel(),
			label: i18n.get(this.toggleLabel)
		})
		this.toggle.on('change', () => {
			this._uiState()

			if (this.showLabel()) {
				this.$('[name=label]').focus()
			}

			this.formView.validate()
		})
		this.$('.toggle-container').append(this.toggle.el)
		this.toggle.render()

		this._uiState()

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: (val) => {
				if (this.showLabel()) {
					return requiredValidator(val)
				} else {
					return null
				}
			}
		}).render()

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		}).start()

		return this
	},

	_getModelLabel: function () {},
	_setModelLabel: function (label) {},
	_getSuggestion: function () {},

	showLabel: function (show) {
		var input = this.$('[name=showLabel]')
		if (show === undefined) {
			return input.prop('checked')
		} else {
			input.prop('checked', show)
		}
	},

	label: function (label) {
		var input = this.$('input[name=label]')
		if (label === undefined) {
			return input.val()
		} else {
			input.val(label)
		}
	},

	_uiState: function () {
		var showLabel = this.showLabel()
		this.$('.label.widget-title').toggleClass('is-disabled', !showLabel).find('input').prop('disabled', !showLabel)
		if (showLabel && !this.label()) {
			this.suggest()
		}
	},

	suggest: function () {
		if (!this.label()) {
			this.label(this._getSuggestion() || '')
		}
	},

	submit: function () {
		this.model.trigger('record')

		var updated = formHelper.readFromDom(this.el)
		this._setModelLabel(this.showLabel() ? updated.label : null)

		this.trigger('done')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.toggle, this.labelField, this.formView], 'remove')
	}
})

export default ConfigWidgetLabel

ConfigWidgetLabel.__filename__ = 'dashboards/widgets/config-widget-label.js'
